"use strict";

// handle on questionnaires
document.addEventListener("DOMContentLoaded", () => {
  const questionnaires = document.getElementById("questionnaires");
  console.log(questionnaires);
  if (questionnaires) {
    sessionStorage.setItem("questionnaires", questionnaires.value);
  }

  const checkoutUrl = document.getElementById("checkout_url");
  const currentCheckoutUrl = sessionStorage.getItem("questionnaires");
  if (checkoutUrl && currentCheckoutUrl) {
    checkoutUrl.value = currentCheckoutUrl;
  }
});
